import { Button } from "../../components/Button";
import { RolesEmptyStateCard } from "../EmptyStateCard";

interface RoleDetailsEmptyStateProps {
  onAddLicense: () => void;
}

export function RoleDetailsEmptyState(props: RoleDetailsEmptyStateProps) {
  const { onAddLicense } = props;

  return (
    <RolesEmptyStateCard title="You haven't added any licenses yet.">
      <Button fullWidth size="large" variant="contained" onClick={onAddLicense}>
        Add License
      </Button>
    </RolesEmptyStateCard>
  );
}
